import React from "react";
import ExternalScripts from "../../../common/ExternalScripts";
import Testimonials from "../../Home/components/Testimonials";
import PricingSection from "../../Home/components/PricingSection";
import FunFactSection from "../../Home/components/FunFactSection";
import WhyChooseSection from "../../Home/components/WhyChooseSection";

const AboutSection = () => {
  return (
    <div>
      <ExternalScripts/>
      {/* about-inner-one */}
      <section className="about-inner-one layout-radius">
        <div className="upper-box">
          <div className="boxcar-container">
            <div className="row wow fadeInUp">
              <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="boxcar-title">
                  <ul className="breadcrumb">
                    <li>
                      <a href="#">Home</a>
                    </li>
                    <li>
                      <span>Cars for Sale</span>
                    </li>
                  </ul>
                  <h2>About Us</h2>
                  <div className="text">
                      Making car buying simple, transparent, and hassle-free
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="content-box">
                  <div className="text">
                         Car Junction is a trusted car selling platform where we list and sell
            cars directly to buyers. Our goal is to make the car buying process
            simple, clear, and convenient for everyone.
                  </div>
                  <div className="text">
                    Every car listed on our platform is carefully reviewed and presented
            with accurate details and real images. Buyers can browse available
            cars and connect with our team instantly through WhatsApp for quick
            assistance.
                  </div>
                  <div className="text">
                     At Car Junction, we believe in honest pricing, transparent
            communication, and providing a smooth buying experience from first
            inquiry to final purchase.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* gallery-sec */}
        <div className="galler-section">
          <div className="boxcar-container">
            <div className="row">
              <div className="exp-block col-md-2 col-sm-12">
                <div className="inner-box">
                  <div className="exp-box">
                    <h2 className="title">4</h2>
                    <div className="text">Years in Business</div>
                  </div>
                  <div className="image-box">
                    <figure className="image">
                      <img src="images/resource/about-inner1-1.jpg"   />
                    </figure>
                  </div>
                </div>
              </div>
              <div className="image-block style-center col-md-5 col-sm-12">
                <div className="image-box">
                  <figure className="image">
                    <img src="images/resource/about-inner1-2.jpg"   />
                  </figure>
                </div>
              </div>
              <div className="image-block col-md-5 col-sm-12">
                <div className="image-box two">
                  <figure className="image">
                    <img src="images/resource/about-inner1-3.jpg"   />
                  </figure>
                </div>
                <div className="row box-double-img">
                  <div className="image-block col-lg-5 col-5">
                    <div className="image-box">
                      <figure className="image">
                        <img src="images/resource/about-inner1-4.jpg"   />
                      </figure>
                    </div>
                  </div>
                  <div className="image-block col-lg-7 col-7">
                    <div className="image-box">
                      <figure className="image">
                        <img src="images/resource/about-inner1-5.jpg"   />
                      </figure>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End gallery sec */}
        {/* why choose us section */}
        <WhyChooseSection/>
        {/* End why choose us section */}
        <PricingSection/>
       <FunFactSection/>
        {/* brand section */}
        {/* End brand section */}
       
        {/* boxcar-testimonial-section-four */}
       <Testimonials/>
        {/* End boxcar-testimonial-section-four */}
        {/* faq-section */}
        <div className="faqs-section pt-0">
          <div className="inner-container">
            {/* FAQ Column */}
            <div className="faq-column wow fadeInUp" data-wow-delay="400ms">
              <div className="inner-column">
                <div className="boxcar- text-center">
                  <h2 className="title">See Frequently Asked Questions</h2>
                </div>
                <ul className="widget-accordion wow fadeInUp">
                  {/*Block*/}
                  <li className="accordion block active-block">
                    <div className="acc-btn active">
                      What is Car Junction ? 
                      <div className="icon fa fa-plus" />
                    </div>
                    <div className="acc-content current">
                      <div className="content">
                        <div className="text">
                          Car Junction is a car listing platform where users can browse cars and directly connect with sellers through WhatsApp for further discussion.
                        </div>
                      </div>
                    </div>
                  </li>
                  {/*Block*/}
                  <li className="accordion block">
                    <div className="acc-btn">
                      How can I contact the seller?
                      <div className="icon fa fa-plus" />
                    </div>
                    <div className="acc-content">
                      <div className="content">
                        <div className="text">
                          Each car listing includes a “Chat on WhatsApp” option that allows you to directly contact the seller for price, availability, and other details.
                        </div>
                      </div>
                    </div>
                  </li>
                  {/*Block*/}
                  <li className="accordion block">
                    <div className="acc-btn">
                      Do you offer test drives or inspections?
                      <div className="icon fa fa-plus" />
                    </div>
                    <div className="acc-content">
                      <div className="content">
                        <div className="text">
                         Test drive and inspection details are discussed directly on WhatsApp, depending on the car and location.
                        </div>
                      </div>
                    </div>
                  </li>
                  {/*Block*/}
                  <li className="accordion block">
                    <div className="acc-btn">
                      Are there any hidden charges?
                      <div className="icon fa fa-plus" />
                    </div>
                    <div className="acc-content">
                      <div className="content">
                        <div className="text">
                          No. We follow transparent pricing. Any applicable costs are clearly communicated before you proceed with the purchase.
                        </div>
                      </div>
                    </div>
                  </li>
                  {/*Block*/}
                  <li className="accordion block">
                    <div className="acc-btn">
                      Are the cars inspected before listing?
                      <div className="icon fa fa-plus" />
                    </div>
                    <div className="acc-content">
                      <div className="content">
                        <div className="text">
                         Yes. Every car is inspected for condition and basic documentation before being listed on our platform.
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="accordion block">
                    <div className="acc-btn">
                      Can I negotiate the car price?
                      <div className="icon fa fa-plus" />
                    </div>
                    <div className="acc-content">
                      <div className="content">
                        <div className="text">
                         Price discussions and negotiations are handled directly through WhatsApp with our sales team.
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="accordion block">
                    <div className="acc-btn">
                      Is test drive available?
                      <div className="icon fa fa-plus" />
                    </div>
                    <div className="acc-content">
                      <div className="content">
                        <div className="text">
                         Test drive availability depends on the car and location. Please contact us on WhatsApp for details.
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* End faqs-section */}
      </section>
      {/* End about-inner-one */}
    </div>
  );
};

export default AboutSection;
